import { styled } from '@mui/material';

import { isBefore } from 'date-fns';

import { Loader } from '@app-velocity/animations';
import { useI18n } from '@app-velocity/i18n';
import {
  PaymentPlansContext,
  PlanOptions,
  SubscriptionDetails,
} from '@app-velocity/modules/payments';
import { useGetTeamSubscriptionInfoQuery } from '@app-velocity/libs/teams-data-access';
import { Container, Page } from '@app-velocity/ui';

import { useTeamAdminContext } from '../../context';

const PlansContainer = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  overflowX: 'auto',
});

export const Billing = () => {
  const { t } = useI18n();
  const { team, userTeam } = useTeamAdminContext();
  const { data: subInfo, isLoading } = useGetTeamSubscriptionInfoQuery(
    team.id || null
  );

  if (isLoading) return <Loader />;

  if (!subInfo || !userTeam.subscriptionTier) return null;

  const { currentPeriodEnd, willAutoRenew } = subInfo;

  return (
    <Page>
      <Page.Header title={t('teams:billing.title')} />
      <Page.Content>
        <Container>
          <PaymentPlansContext.Provider
            value={{
              mainPath: '/',
              subscribedUntil: currentPeriodEnd
                ? new Date(currentPeriodEnd)
                : null,
              autoRenew: willAutoRenew || false,
              subscribed:
                !!currentPeriodEnd &&
                isBefore(new Date(), new Date(currentPeriodEnd)),
              tier: userTeam.subscriptionTier,
            }}
          >
            <SubscriptionDetails />
            <PlansContainer>
              <PlanOptions />
            </PlansContainer>
          </PaymentPlansContext.Provider>
        </Container>
      </Page.Content>
    </Page>
  );
};
